import axios from 'axios';
import { getApiBaseUrl } from '../../core/config/api';

export interface LoginData {
  email: string;
  password: string;
}

export interface SignupData {
  username: string;
  email: string;
  password: string;
  invitation_code: string;
}

export interface User {
  id: number;
  username: string;
  email: string;
  created_at: string;
  roles_id?: number;
  activated?: boolean;
}

export interface AuthResponse {
  success: boolean;
  message?: string;
  error?: string;
  user?: User;
  token?: string;
  /** Secondes restantes en cas de HTTP 429 (anti-brute-force) */
  retryAfterSeconds?: number;
}

class AuthService {
  private static instance: AuthService;

  private constructor() {}

  public static getInstance(): AuthService {
    if (!AuthService.instance) {
      AuthService.instance = new AuthService();
    }
    return AuthService.instance;
  }

  /**
   * Authentification d'un utilisateur
   */
  async login(data: LoginData): Promise<AuthResponse> {
    try {
      const response = await axios.post<AuthResponse>(
        `${getApiBaseUrl(true)}/auth/login`,
        data,
        {
          headers: {
            'Content-Type': 'application/json',
          },
          timeout: 10000,
        }
      );

      return response.data;
    } catch (error: any) {
      if (error.response) {
        const data = error.response.data;
        return {
          success: false,
          error: data?.error || 'Erreur lors de la connexion',
          retryAfterSeconds:
            typeof data?.retryAfter === 'number' ? data.retryAfter : undefined,
        };
      } else if (error.request) {
        // Pas de réponse du serveur
        return {
          success: false,
          error: 'Impossible de contacter le serveur. Vérifiez votre connexion.',
        };
      } else {
        // Erreur lors de la configuration de la requête
        return {
          success: false,
          error: 'Erreur lors de la requête de connexion',
        };
      }
    }
  }

  /**
   * Inscription d'un nouvel utilisateur
   */
  async signup(data: SignupData): Promise<AuthResponse> {
    try {
      const response = await axios.post<AuthResponse>(
        `${getApiBaseUrl(true)}/auth/register`,
        data,
        {
          headers: {
            'Content-Type': 'application/json',
          },
          timeout: 10000,
        }
      );

      return response.data;
    } catch (error: any) {
      if (error.response) {
        const data = error.response.data;
        return {
          success: false,
          error: data?.error || 'Erreur lors de l\'inscription',
          retryAfterSeconds:
            typeof data?.retryAfter === 'number' ? data.retryAfter : undefined,
        };
      } else if (error.request) {
        // Pas de réponse du serveur
        return {
          success: false,
          error: 'Impossible de contacter le serveur. Vérifiez votre connexion.',
        };
      } else {
        // Erreur lors de la configuration de la requête
        return {
          success: false,
          error: 'Erreur lors de la requête d\'inscription',
        };
      }
    }
  }
}

export default AuthService;

